import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=3010d53e&scoped=true&"
import script from "./Textfield.vue?vue&type=script&lang=ts&"
export * from "./Textfield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010d53e",
  null
  
)

export default component.exports